/**
 * Desktop left rail shared by build, browse, admin, and ops shells.
 * Ancestors must use overflow-x: clip (not hidden) or position:sticky fails.
 */
export const STICKY_PAGE_RAIL_CLASS =
  'sticky-page-rail hidden lg:flex flex-col sticky top-20 z-20 w-60 xl:w-64 shrink-0 self-start max-h-[calc(100vh-6rem)] rounded-xl overflow-hidden';
